export default __webpack_public_path__ + "dd6d86ce1e24b486c486118e9b3c9f8b.svg";